export default "__VITE_ASSET__DHazfCXF__"